const initials = "exams/";

export const UPDATE_CANDIDATES = `${initials}UPDATE_CANDIDATES`;
export const UPDATE_FILTER = `${initials}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${initials}UPDATE_REDUCER`;